module.exports = __webpack_public_path__ + "img/confeti.a6ea5995.png";